import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { statesvilleConfig } from "./data";

export default function StatesvillePage() {
  return <CityPageTemplate config={statesvilleConfig} />;
}